/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import ErrorBoundary from '../../src/components/ErrorBoundary'

export const wrapRootElement = ({ element }) => {
  return <ErrorBoundary location="page component">{element}</ErrorBoundary>
}
